import React, {Component,useEffect, useState} from 'react';
import {withRouter} from 'react-router';
import ContactWaySty from './contentContactWay.module.css';
import $ from 'jquery';
import {getBusiness, getBusinessCate} from "../BussinessScope/service";


import qq_icon from '../../images/qq.png';
import wechat_icon from '../../images/wechat.png';
import call_icon from '../../images/call.png';
import backTop_icon from '../../images/back_to_top.png';
import back_icon from '../../images/back.png';
import home_wechat_icon from '../../images/home_wechat_icon.png';
import home_wechat from '../../images/home_wechat.png';

import './contentContactWay.css';

const contactWayData=[
    {key:0,itemicon:qq_icon},
    {key:1,itemicon:wechat_icon},
    {key:2,itemicon:call_icon},
    {key:3,itemicon:backTop_icon},
    {key:5,itemicon:home_wechat_icon},
    {key:4,itemicon:back_icon},
];


const ContactWay =(props) =>{
    const {history} = props;
    const [isEnterItem,setIsEnterItem]=useState(false);
    const [ids,setIds]=useState([]);

    useEffect(() => {
        (async () => {
            const businessCate = await getBusinessCate({page: 1, size: 100});
            const business = await getBusiness({page: 1, size: 100});
            let tempIds=[];
            business.data.list.map((item,index)=>{
                if(item.cate_id === businessCate.data.list[0].id)
                tempIds.push(item.id)
            })
            setIds(tempIds);
        })();
    },[])


    useEffect(() => {
        onItemAnimateStyle();
    },[isEnterItem])

    const onItemAnimateStyle=()=>{
        playAnimate('#li0','#item0',{width:'150px'},100,{width:'0px'},200);
        playAnimate('#li1','#item1',{width:'160px'},100,{width:'0px'},100);
        playAnimate('#li2','#item2',{width:'250px'},100,{width:'0px'},100);
        playAnimate('#li3','#item3',{width:'150px'},100,{width:'0px'},200);
        playAnimate('#li4','#item4',{width:'150px'},100,{width:'0px'},200);
        playAnimate('#li5','#item5',{width:'160px'},100,{width:'0px'},100);


        let itemArr=['#item0','#item1','#item2','#item3','#item4','#item5'];
        itemArr.map((item, index)=>{
            $(item).mouseenter(()=>{
                $(item).stop();
            });
            $(item).mouseleave(()=>{
                $(item).animate({width:'0px'},200);
            });
        });
        // $('#item0').mouseenter(()=>{
        //     $('#item0').stop();
        // });
        // $('#item0').mouseleave(()=>{
        //     $('#item0').animate({width:'0px'},200);
        // });

        // $('#item0').hover(()=>{
        //     $('#item0').stop();
        // },()=>{
        //     $('#item0').animate({width:'0px'},200);
        // })
    }

    const playAnimate=(liId,itemId,enterStyle,enterValue,leaveStyle,leaveValue)=>{
        $(liId).mouseenter(()=>{
            $(itemId).stop();
            $(itemId).animate(enterStyle,enterValue);
        });

        $(liId).mouseleave(()=>{
            $(itemId).stop();
            $(itemId).animate(leaveStyle,leaveValue);
        });

        // $(liId).hover(()=>{
        //     $(itemId).stop();
        //     $(itemId).animate(enterStyle,enterValue);
        // },()=>{
        //     $(itemId).stop();
        //     $(itemId).animate(leaveStyle,leaveValue);
        // });
    }
    

    const scrollBackTop=(index)=>{
        let pathname=props.location.pathname;
        // console.log(history)
        if(3 === index)
           window.scrollTo(0,0);
        if(4 === index){
            history.goBack();
        }
    }


    let contactWayLis=contactWayData.map(({key,itemicon,title})=>{
        return(
            <li key={key} id={`li`+key} onClick={()=>{scrollBackTop(key)}} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>
                <div className={ContactWaySty.iconSty} style={{backgroundImage:`url(${itemicon})`}}></div>  
            </li>
        );
    });

    
    return (
         // http://wpa.qq.com/msgrd?v=3&uin=123456789&site=qq&menu=yes
        // tencent://message/?uin=123456789&Site=Sambow&Menu=yes
        //http://wpa.qq.com/msgrd?v=3&uin=1164596542&site=qq&menu=yes

        <div id="contactWayDiv" className={ContactWaySty.contactWayDiv}>
            <ul>
                {contactWayLis}
            </ul>

            <div id="item0" className={ContactWaySty.item0Sty} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>
                <div className={ContactWaySty.itemQQiconSty}></div>
                <div className={ContactWaySty.itemQQtextSty}><a target="_blank" href="https://qm.qq.com/cgi-bin/qm/qr?k=YzLEv5ntpRpJKcUHc7FIeTHgT6VfKItM&authKey=CZgfjabYekvJIm2FsNUJS1UoySRaMi9IkqMYHxXAUGUDERT10XMwxTyLQynI0ch5&noverify=0&group_code=1164596542">我要咨询</a></div>
            </div>


            <div id="item1" className={ContactWaySty.item1Sty} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>
                <div className={ContactWaySty.itemQrcodeSty}></div>
                <div className={ContactWaySty.itemWechatTextSty}>最新专业资讯</div>
            </div>

            <div id="item2" className={ContactWaySty.item2Sty} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>
                <div className={ContactWaySty.itemCallIconSty}></div>
                <div className={ContactWaySty.itemPhoneSty}>办公电话：010-68666221</div>
            </div>

            <div id="item3" className={ContactWaySty.item3Sty} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>
                <div className={ContactWaySty.itemCallIconSty}></div>
                <div className={ContactWaySty.itemPhoneSty}><a onClick={()=>{scrollBackTop(3)}}>返回顶部</a></div>
            </div>

            <div id="item5" className={ContactWaySty.item5Sty} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>                 
                <div className={ContactWaySty.itemQrcodeSty}></div>                 
                <div className={ContactWaySty.itemWechatTextSty}></div>             
            </div>

            <div id="item4" className={ContactWaySty.item4Sty} onMouseOver={()=>{setIsEnterItem(true)}} onMouseLeave={()=>{setIsEnterItem(false)}}>
                <div className={ContactWaySty.itemCallIconSty}></div>
                <div className={ContactWaySty.itemPhoneSty}><a onClick={()=>{scrollBackTop(4)}}>返回上一页</a></div>
            </div>
        </div>
    );
}

export default withRouter(ContactWay);

